// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_fa","menuControls_styleDefault":"c-a_fb","menuControls_styleRed":"c-a_fc"};